var _path, _path2, _path3, _path4, _path5, _path6, _path7;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgStorytelling(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.16 9.402a3.477 3.477 0 004.9-.3l1.933-2.166a3.477 3.477 0 00-.3-4.9 3.477 3.477 0 00-4.9.3l-1.934 2.166c-1.266 1.434-1.133 3.6.3 4.9z",
    fill: "#0C0A0C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.626 3.202l5.633 5",
    stroke: "#fff",
    strokeWidth: 0.667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.193 21.002l1.8 1.6c.233.2.6.2.833-.033l11.4-11.7a.596.596 0 00-.033-.867l-2.867-2.566c-.267-.234-.633-.2-.867.066L2.16 20.17c-.233.267-.2.633.034.833z",
    stroke: "#0C0A0C",
    strokeWidth: 0.333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.393 12.002l6.066 5.4c.133.1.3.1.4-.033l5.4-6.067c.1-.133.1-.3-.033-.4l-6.067-5.4c-.133-.1-.3-.1-.4.034l-5.4 6.066c-.1.134-.1.3.034.4z",
    fill: "#89EC54"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.544 11.66c.028-1.105-1.008-2.027-2.315-2.06-1.307-.033-2.389.835-2.417 1.94-.028 1.104 1.008 2.026 2.315 2.059 1.307.033 2.389-.835 2.417-1.94z",
    stroke: "#0C0A0C",
    strokeWidth: 0.333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.593 14.236c.366.066.766.166 1.2.3.6.166 1.166.366 1.633.566",
    fill: "#89EC54"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.593 14.236c.366.066.766.166 1.2.3.6.166 1.166.366 1.633.566M16.426 17.102c.1.367.167.767.233 1.234.1.633.134 1.2.134 1.733M17.56 15.969s2.066 1.167 2.8 1.967M6.526 8.402a10.495 10.495 0 01-1.2-.3 13.23 13.23 0 01-1.633-.566M8.726 5.536c-.1-.367-.167-.767-.233-1.234-.1-.633-.134-1.2-.134-1.733M7.593 6.636s-2.067-1.167-2.8-1.967",
    stroke: "#0C0A0C",
    strokeWidth: 0.333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

export default SvgStorytelling;